module.exports = __webpack_public_path__ + "static/jobFront-23a978bb64d13936fc400848693c808a.jpg";